<template>
  <Accordion :lazy="spheres?.length > 100" :activeIndex="activeIndex" :multiple="true"
             expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
    <AccordionTab v-for="(sphere, i) in spheres" :key="sphere.id">
      <template #header>
        <div class="flex full-width mr">
          <div class="flex-3">
            <i class="pi pi-folder"/> {{ sphere.name }}
            <Button label="Enter Sphere" type="button" @click="changeSphere(sphere.id)" class="ml enter-sphere-button"></Button>
          </div>
          <div class="flex-1 align-self-center">
            {{ sphere.children?.length ? sphere.children.length + ' sub-sphere' + ( sphere.children?.length === 1 ? '' : 's') : '' }}
          </div>
        </div>
      </template>
      <SphereAccordion @enterSphere="enterSphere" @open="openEvent(i)" :search-text="searchText" :spheres="sphere.children" v-if="sphere.children?.length"></SphereAccordion>
    </AccordionTab>
  </Accordion>

</template>

<script setup>
import { nextTick, ref, watch } from "vue";
import { selectedAccount } from "../store/state.js";
import { useRouter } from "vue-router";

const router = useRouter()

const activeIndex = ref([])

const props = defineProps({
  spheres: Array,
  searchText: String
})

const emit = defineEmits([
    'open',
    'enterSphere',
])

function enterSphere() {
  emit('enterSphere')
}

function changeSphere(id) {
  selectedAccount.value = id
  router.push('/')
  enterSphere()
}

function openEvent(i) {
  nextTick(() => {
    if (!props.spheres[i]?.children?.length || !props.spheres[i]?.children?.length < 50) {
      activeIndex.value.push(i)
    }
    emit('open')
  })
}

watch(() => props.searchText, (newValue) => {
  activeIndex.value = []
  if (newValue) {
    nextTick(() => {
      let indexes = []
      let shouldEmit = false
      for (let i = 0; i < props.spheres?.length; i++) {
        if (props.spheres[i]?.name?.toLowerCase()?.includes(newValue)) {
          indexes.push(i)
          shouldEmit = true
        }
      }
      if (shouldEmit) {
        emit('open')
      }
      if (indexes.length < 20) {
        activeIndex.value.push(...indexes)
      }
    })
  }
}, { immediate: true })

</script>

<style scoped>
:deep(.p-accordion-header .p-accordion-header-link) {
  color: #ffffff;
  background: #2259A2;
}

:deep(.p-accordion-content) {
  background-color: transparent;
}

:deep(.p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link),
:deep(.p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link) {
  color: #ffffff;
  background: #60A5F9;
}

:deep(.p-accordion-header .p-accordion-header-link),
:deep(.p-accordion-tab .p-accordion-content),
:deep(.p-accordion-tab:last-child .p-accordion-content) {
  border-radius: 0 !important;
}

:deep(.p-accordion-tab) {
  border: 0;
}

.enter-sphere-button {
  padding-top: .5rem;
  padding-bottom: .5rem;
}
</style>